export default "__VITE_ASSET__a9S9DVj3__"